import React from 'react';
import PropTypes from 'prop-types';
import { DarkScreenMask, PrimaryButton } from "../..";
import deleteIcon from '../../assets/imgs/Icon-Delete.svg';
import assignIcon from '../../assets/imgs/Icon-Assign.svg';
import shareIcon from '../../assets/imgs/Icon-ShareVideo.svg';
import downloadIcon from '../../assets/imgs/Icon-Download.svg';

const Menu = ({ isVisible, onDeleteClick, onDownloadClick, onShareClick, onAssignClick })=> {

  const menuItems = [
    { title: "Share", icon: shareIcon, isVisible: true, callback: onShareClick},
    { title: "Delete", icon: deleteIcon, isVisible: true, callback: onDeleteClick},
    { title: "Assign", icon: assignIcon, isVisible: true, callback: onAssignClick},
    { title: "Download", icon: downloadIcon, isVisible: true, callback: onDownloadClick},
  ];

  return (
    <DarkScreenMask isVisible={isVisible}>
      <div className="video-preview__menu">
        {menuItems.map(item => 
          item.isVisible ?
            <PrimaryButton 
              key={item.title} 
              className="video-preview__menu__button"
              onClick={item.callback}
            >
              <img style={{ height: "35px", width: "35px" }} src={item.icon} alt="" />
              <span style={{ fontSize: "12px", color: "white" }}>{item.title}</span>
            </PrimaryButton> :
            null
        )}
      </div>
    </DarkScreenMask>
  );
};

Menu.propTypes = {
  isVisible: PropTypes.bool,
  onAssignClick: PropTypes.func, 
  onDeleteClick: PropTypes.func, 
  onDownloadClick: PropTypes.func, 
  onShareClick: PropTypes.func
};

Menu.defaultProps = {
  isVisible: false,
  onAssignClick: ()=> {}, 
  onDeleteClick: ()=> {}, 
  onDownloadClick: ()=> {}, 
  onShareClick: ()=> {}
}

export default Menu;